import { render, staticRenderFns } from "./archivingTxnDetail.vue?vue&type=template&id=7c3779f8&scoped=true&"
import script from "./archivingTxnDetail.vue?vue&type=script&lang=js&"
export * from "./archivingTxnDetail.vue?vue&type=script&lang=js&"
import style0 from "./archivingTxnDetail.vue?vue&type=style&index=0&id=7c3779f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3779f8",
  null
  
)

export default component.exports